module.exports = __webpack_public_path__ + "media/images/application/template/logo-2ff1052c8740864aded4bb3b52ecc6ef.svg";